var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlayingStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C12 2.79086 13.7909 1 16 1C18.2091 1 20 2.79086 20 5V12C20 14.2091 18.2091 16 16 16C13.7909 16 12 14.2091 12 12V5ZM16.75 18.9603C20.2633 18.5861 23 15.6126 23 12C23 11.5858 22.6642 11.25 22.25 11.25C21.8358 11.25 21.5 11.5858 21.5 12C21.5 15.0376 19.0376 17.5 16 17.5C12.9624 17.5 10.5 15.0376 10.5 12C10.5 11.5858 10.1642 11.25 9.75 11.25C9.33579 11.25 9 11.5858 9 12C9 15.6126 11.7367 18.5861 15.25 18.9603V21.5H13C12.5858 21.5 12.25 21.8358 12.25 22.25C12.25 22.6642 12.5858 23 13 23L13.0039 23H15.25H16.75H19C19.4142 23 19.75 22.6642 19.75 22.25C19.75 21.8358 19.4142 21.5 19 21.5H16.75V18.9603Z",
    fill: "white",
    fillOpacity: 0.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8H20V12C20 14.2091 18.2091 16 16 16C13.7909 16 12 14.2091 12 12V8Z",
    fill: "#23D959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 12,
    y: 8,
    width: 8,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlayingStep5);
export default __webpack_public_path__ + "static/media/audio_playing_step5.173f549af41f2bde74946c0ae20e465c.svg";
export { ForwardRef as ReactComponent };